<template>
  <div class="wrapper">
    <div class="ad-holder" v-if="!userDetails?.premiumGames?.includes('geogrid')">
      <div id="adngin-sb_left-0"></div>
      <div id="adngin-sb_bottom_left-0"></div>
    </div>
  </div>
</template>

<script>
  import { activateAdUnit } from '../../utils/ads';
  import { inject } from 'vue';

  export default {
    name: 'SbLeftAd',
    inject: ['isAdScriptLoaded'],
    watch: {
      isAdScriptLoaded: {
        handler(isLoaded) {
          if (!isLoaded) return;
          if (window.innerWidth < 1415) return;
          activateAdUnit('sb_left');
          activateAdUnit('sb_bottom_left');
        },
        immediate: true,
      },
    },
    setup() {
      return {
        userDetails: inject('userDetails'),
      };
    },
  };
</script>

<style scoped>
  .wrapper {
    width: 350px;
    min-height: 500px;
    padding: 0.8rem;
    position: sticky;
    top: 0;
  }
  .ad-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  @media (max-width: 1415px) {
    .wrapper {
      display: none;
    }
  }
</style>
